import { render, staticRenderFns } from "./IncidentNew.vue?vue&type=template&id=7349826a&scoped=true"
import script from "./IncidentNew.vue?vue&type=script&lang=js"
export * from "./IncidentNew.vue?vue&type=script&lang=js"
import style0 from "./IncidentNew.vue?vue&type=style&index=0&id=7349826a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7349826a",
  null
  
)

export default component.exports